import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-brigades-actions-block',
  templateUrl: './brigades-actions-block.component.html',
  styleUrls: ['./brigades-actions-block.component.scss'],
  standalone: false,
})
export class BrigadesActionsBlockComponent implements OnInit {
  @Input() brigadeOperations;
  @Output() onOpenDisbandmentConfirmDialog = new EventEmitter<any>();
  @Output() onOpenMergeDialog = new EventEmitter<any>();
  @Output() onUpdateWidget = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}
}
